import { render, staticRenderFns } from "./UnloadingBaseList.vue?vue&type=template&id=8dfa2d54&lang=pug"
import script from "./UnloadingBaseList.vue?vue&type=script&lang=js"
export * from "./UnloadingBaseList.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports